import { createSlice } from "@reduxjs/toolkit";
import { LoadState } from "../../constants/enums";
import { initialInsuranceReportsState } from "./insuranceReports.types";
import {
  fetchNoPolicyInsuranceReportsList,
  fetchNoPolicyInsuranceReport,
} from "./insuranceReportsThunk";
import { APIError } from "../../constants/types";

const insuranceReportsSlice = createSlice({
  name: "insuranceReports",
  initialState: initialInsuranceReportsState,
  reducers: {
    clearInsuranceReportsState: () => {
      return initialInsuranceReportsState;
    },
    clearNoPolicyInsuranceReport: (state) => {
      state.dataLoading = LoadState.NotLoaded;
      state.data = initialInsuranceReportsState.data;
    },
    // Sync reducers used by legacy thunks in insuranceReportsActions.ts
    setInsuranceReportsListLoading: (state) => {
      state.loading = LoadState.InProgress;
      state.list = [];
      state.totalRecords = 0;
    },
    setInsuranceReportsListSuccess: (state, action) => {
      state.loading = LoadState.Loaded;
      state.list = action.payload.list;
      state.totalRecords = action.payload.totalRecords;
    },
    setInsuranceReportsListFailed: (state) => {
      state.loading = LoadState.Failed;
      state.list = [];
      state.totalRecords = 0;
    },
    setInsuranceReportsListV2Loading: (state) => {
      state.loadingV2 = LoadState.InProgress;
      state.listV2 = [];
      state.totalRecordsV2 = 0;
    },
    setInsuranceReportsListV2Success: (state, action) => {
      state.loadingV2 = LoadState.Loaded;
      state.listV2 = action.payload.listV2;
      state.totalRecordsV2 = action.payload.totalRecordsV2;
    },
    setInsuranceReportsListV2Failed: (state) => {
      state.loadingV2 = LoadState.Failed;
      state.listV2 = [];
      state.totalRecordsV2 = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      // No-policy list
      .addCase(fetchNoPolicyInsuranceReportsList.pending, (state) => {
        state.noPolicyLoading = LoadState.InProgress;
        state.noPolicyList = [];
        state.noPolicyTotalRecords = 0;
      })
      .addCase(fetchNoPolicyInsuranceReportsList.fulfilled, (state, action) => {
        state.noPolicyLoading = LoadState.Loaded;
        state.noPolicyList = action.payload.data;
        state.noPolicyTotalRecords = action.payload.totalRecords;
      })
      .addCase(fetchNoPolicyInsuranceReportsList.rejected, (state) => {
        state.noPolicyLoading = LoadState.Failed;
        state.noPolicyList = [];
        state.noPolicyTotalRecords = 0;
      })
      // Single no-policy report
      .addCase(fetchNoPolicyInsuranceReport.pending, (state) => {
        state.dataLoading = LoadState.InProgress;
        state.data = initialInsuranceReportsState.data;
      })
      .addCase(fetchNoPolicyInsuranceReport.fulfilled, (state, action) => {
        state.dataLoading = LoadState.Loaded;
        state.data = action.payload;
      })
      .addCase(fetchNoPolicyInsuranceReport.rejected, (state, action) => {
        state.dataLoading = LoadState.Failed;
        state.data = initialInsuranceReportsState.data;
        state.error = (action.payload as APIError).message;
      });
  },
});

export const {
  clearInsuranceReportsState,
  clearNoPolicyInsuranceReport,
  setInsuranceReportsListLoading,
  setInsuranceReportsListSuccess,
  setInsuranceReportsListFailed,
  setInsuranceReportsListV2Loading,
  setInsuranceReportsListV2Success,
  setInsuranceReportsListV2Failed,
} = insuranceReportsSlice.actions;

export const insuranceReducer = insuranceReportsSlice.reducer;
